import type { FC } from 'react';
import styles from './QuestionLevel.module.css';
import type { QuestionLevelProps } from './QuestionLevel.types';
import { getClasses } from '@/_utils/classnames';
import { Flex } from '@/_components';

export const QuestionLevel: FC<QuestionLevelProps> = ({ children, level }) => {
  const questionLevelClasses: string = getClasses(styles.questionLevel, {
    [styles.questionLevel1]: level === 1,
    [styles.questionLevel2]: level === 2,
    [styles.questionLevel3]: level === 3,
  });
  return (
    <Flex isColumn={true} className={questionLevelClasses}>
      {children}
    </Flex>
  );
};
